var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAusrichtenBlock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: ".._.._src_svg_Icn_40px_Ausrichten_Block__Icn/40px/Ausrichten_Block",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: ".._.._src_svg_Icn_40px_Ausrichten_Block__Color/Transp_00",
    opacity: 0
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H40V40H0z",
    id: ".._.._src_svg_Icn_40px_Ausrichten_Block__Rectangle"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M9,16 L31,16 L31,18 L9,18 Z M9,11 L31,11 L31,13 L9,13 Z M9,21 L31,21 L31,23 L9,23 Z M9,26 L31,26 L31,28 L9,28 Z",
    id: ".._.._src_svg_Icn_40px_Ausrichten_Block__Combined-Shape"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAusrichtenBlock);
export default __webpack_public_path__ + "static/media/Ausrichten_Block.25a0126306eef75d2eb05f5b114dcc51.svg";
export { ForwardRef as ReactComponent };